<template>
  <div class="main">

    <div class="top">
      <div class="back" @click="back"><i class="el-icon-arrow-left"></i>返回</div>
      <div class="topTitle">{{ comName }}</div>
      <div style="display: inline-block;cursor: pointer;font-size: 24px;" v-if="contentType==2" @click="viewReport"><i class="el-icon-zoom-in"></i></div>
    </div>

    <div class="content" v-if="contentType==1">
      <div v-if="!showBuy">
        <table class="selectTable">
          <tr>
            <td>年份</td>
            <template v-for="(item, index) in reportYearList">
              <td>{{item}}年</td>
            </template>
          </tr>
          <tr>
            <td>年报</td>
            <template v-for="(item, index) in reportTimeListOne">
              <td v-if="item!=null">
                <span @click="viewReportFree(item)"><i class="el-icon-document"></i></span>
                <div v-if="item>=reportFreeIndex" class="freeText">
                  <div class="freeBox">免费</div>
                </div>
              </td>
              <td v-else></td>
            </template>
          </tr>
          <tr>
            <td>三季报</td>
            <template v-for="(item, index) in reportTimeListTwo">
              <td v-if="item!=null">
                <span @click="viewReportFree(item)"><i class="el-icon-document"></i></span>
                <div v-if="item>=reportFreeIndex" class="freeText">
                  <div class="freeBox">免费</div>
                </div>
              </td>
              <td v-else></td>
            </template>
          </tr>
          <tr>
            <td>中报</td>
            <template v-for="(item, index) in reportTimeListThree">
              <td v-if="item!=null">
                <span @click="viewReportFree(item)"><i class="el-icon-document"></i></span>
                <div v-if="item>=reportFreeIndex" class="freeText">
                  <div class="freeBox">免费</div>
                </div>
              </td>
              <td v-else></td>
            </template>
          </tr>
          <tr>
            <td>一季报</td>
            <template v-for="(item, index) in reportTimeListFour">
              <td v-if="item!=null">
                <span @click="viewReportFree(item)"><i class="el-icon-document"></i></span>
                <div v-if="item>=reportFreeIndex" class="freeText">
                  <div class="freeBox">免费</div>
                </div>
              </td>
              <td v-else></td>
            </template>
          </tr>
          
        </table>
      </div>

      <!-- <div>
        <el-select v-model="reportTimeIndex" @change="changeReportIndex">
          <el-option v-for="(item, index) in reportTimeFreeList" :key="item.id" :label="item.name" :value="index" />
        </el-select>
      </div> -->
      <div style="position: relative;left: 1130px;top: 25px;height: 0;">
        <el-button type="danger" icon="el-icon-close" circle @click="showBuy=false"></el-button>
      </div>
      <img v-if="showBuy" src="../../../static/img/report_image.png" width="1200" class="reportimg">
      <!-- <iframe v-if="!showBuy" id="iframe-article" :style="'width: 100%;border: 0;height: '+iframeHeight+'px;'" :src="shareUrl"></iframe> -->
    </div>
    <div class="content" v-if="contentType==2">
      <div>
        <el-select v-model="reportTimeIndex" @change="changeReportIndex">
          <el-option v-for="(item, index) in reportTimeList" :key="item.id" :label="item.name" :value="index" />
        </el-select>
      </div>
      <iframe id="iframe-article" :style="'width: 100%;border: 0;height: '+iframeHeight+'px;'" :src="shareUrl"></iframe>
    </div>
    <div class="buyBox" v-if="showBuy">
      <!-- <text class="text1">成为VIP或单次购买即可查看文档</text>
      <text class="text2">最新上市公司报告分析尽在碧湾App</text>
      <text class="text3">新注册用户可查看10篇文章</text> -->
      <div class="text">您的查看次数已用完，成为VIP或单次购买报告即可继续查看</div>
      <img src="../../../static/img/kthy_icon.png" class="img">
      <div>
        <button class="btn" @click="toSubscription">开通会员</button>
        <button class="btn2" @click="buyButton">{{buyButtonText}}</button>
      </div>
    </div>
    <!-- <div class="footer">
      <div class="footerMenu1"> -->
        <!-- <picker bindchange="changeReportIndex" value="{{reportTimeIndex}}" range="{{reportTimeList}}" range-key="name">
          <div class="picker">
            <span>{{reportTimeList[reportTimeIndex].name}}</span>
            <img src="../../static/img/more.png" class="moreIcon">
          </div>
        </picker> -->
        <!-- <el-select v-model="reportTimeIndex" @change="changeReportIndex">
          <el-option v-for="(item, index) in reportTimeList" :key="item.id" :label="item.name" :value="index" />
        </el-select>
      </div>
      <div class="footerMenu2" @click="buyButton">
        <span>{{buyButtonText}}</span>
      </div>
    </div> -->

    <el-dialog :visible="payVisible" width="700px">
      <div>
        <div style="margin-top: -30px;margin-bottom: -15px;">
          <img src="../../../static/img/wxpay-logo.svg" style="width: 154px;height: 34px;">
        </div>
        <div style="text-align: center;">
          <img :src="payUrl" style="width: 200px;height: 200px;">
        </div>
        <div style="margin: 10px auto;width: 176px;display: flex;align-items: center;padding: 8px 12px;background-color: #445f85;">
          <img src="../../../static/img/scan-code.svg" style="width: 40px;height: 40px;">
          <div style="color: #fff;font-size: 13px;margin-left: 9px;">
            <div>请使用微信扫描</div>
            <div>二维码以完成支付</div>
          </div>
        </div>
        <div style="text-align: center;">
          <el-button type="success" plain @click="payOver">支付完成</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- <div style="width: 0;height: 0;">
      <iframe id="myIframe" style="width: 0;height: 0;border: 0;" src=""></iframe>
    </div> -->
  </div>
</template>

<script>
import { sendRequestIndustry, sendRequestCompany } from '../../../static/js/util';

export default {
  data() {
    return {
      token: '',
      comName: '',
      comCode: '',
      year: '2023',
      type: '三季报',
      shareUrl: null,
      thisUrl: null,
      rankMoney: 2500,
      buyButtonText: '购买报告',
      showBuy: false,
      contentType: 1,
      iframeHeight: 200,

      userInfo: null,
      userCode: null,

      reportTimeList: [
        {id: 65051, year: "2023", stage: "年报", name: "2023年年报"},
        {id: 64988, year: "2023", stage: "三季报", name: "2023年三季报"},
        {id: 58892, year: "2023", stage: "中报", name: "2023年中报"}
      ],

      reportYearList: [],
      reportTimeListOne: [],
      reportTimeListTwo: [],
      reportTimeListThree: [],
      reportTimeListFour: [],
      reportFreeIndex: -1,

      reportTimeIndex: 0,
      mydialog: null,

      payUrl: null,
      payVisible: false
    };
  },
  mounted() {
    this.token = localStorage.getItem('satoken');

    this.comCode = this.$route.query.comCode;
    this.comName = this.$route.query.comName;

    setInterval(()=>{
      this.iframeHeight = document.documentElement.clientHeight - 202;
    }, 1000);

    this.getUserInfo();
    
  },
  methods: {
    back() {
      this.$router.go(-1);
      // this.$router.push({
      //   name: 'reportHome'
      // });
    },
    getUserInfo() {
      var url = '/user/userInfo2';
      sendRequestCompany(url, 'get', {'device': 'web-pc'}, { 'satoken': this.token }, (res) => {
        if (res.code == 0) {
          this.userInfo = res.data;
          if(this.userInfo.memberStatus==0 && this.userInfo.level>0) {
            this.contentType = 2;
          }else {
            this.contentType = 1;
          }
        }
        this.getReportDate();
      }, (err) => {
        console.log(err)
      });
    },
    /**
     * 改报告时间
     */
    changeReportIndex(index) {
      // console.log(index)
      this.reportTimeIndex = index;
      this.year = this.reportTimeList[index].year;
      this.type = this.reportTimeList[index].stage;

      this.getReport();

    },
    /**
     * 免费用户查看报告
     */
    viewReportFree(index) {
      this.year = this.reportTimeList[index].year;
      this.type = this.reportTimeList[index].stage;

      this.getReport(true);
    },

    /**
     * 获取已出报告
     */
    getReportDate() {
      let url = '/company/selfOneComNew?code=' + this.comCode;
      sendRequestIndustry(url, 'get', null, (response)=>{
        // console.log(response)
        if (response.data.code === 0) {
          this.comName = response.data.data.comInfoDTO.comName;
          var tempList = response.data.data.comInfoDTO.comReports;
          var timeIndex = 0;
          for(var i=0; i<tempList.length; i++){
            tempList[i].name = tempList[i].year+'年'+tempList[i].stage;
            if(tempList[i].year==response.data.data.year && tempList[i].stage==response.data.data.stage){
              timeIndex = i;
            }
          }
          this.reportTimeList = tempList;
          this.year = response.data.data.year;
          this.type = response.data.data.stage;

          //免费用户
          if(this.contentType==1) {
            var tempFreeIndex = -1;
            for(var i=0; i<tempList.length; i++) {
              if(parseInt(tempList[i].year)<2023 
                || (parseInt(tempList[i].year)==2023 && tempList[i].stage!='年报')) {
                  if(tempFreeIndex==-1)tempFreeIndex = i;
              }
              if(!this.reportYearList.includes(tempList[i].year)) {
                this.reportYearList.push(tempList[i].year)
              }
            }

            this.reportTimeIndex = tempFreeIndex;
            this.reportFreeIndex = tempFreeIndex;
            this.year = tempList[tempFreeIndex].year;
            this.type = tempList[tempFreeIndex].stage;

            //转表格
            for(var i=0; i<tempList.length; i++) {
              var temp = this.reportYearList.indexOf(tempList[i].year);
              if(tempList[i].stage=='年报') {
                this.reportTimeListOne[temp] = i;
              }else if(tempList[i].stage=='三季报') {
                this.reportTimeListTwo[temp] = i;
              }else if(tempList[i].stage=='中报') {
                this.reportTimeListThree[temp] = i;
              }else if(tempList[i].stage=='一季报') {
                this.reportTimeListFour[temp] = i;
              }
            }

            //填充空白
            var yearLength = this.reportYearList.length;
            if(this.reportTimeListOne.length<yearLength) {
              this.reportTimeListOne[yearLength-1]=null;
            }
            if(this.reportTimeListTwo.length<yearLength) {
              this.reportTimeListTwo[yearLength-1]=null;
            }
            if(this.reportTimeListThree.length<yearLength) {
              this.reportTimeListThree[yearLength-1]=null;
            }
            if(this.reportTimeListFour.length<yearLength) {
              this.reportTimeListFour[yearLength-1]=null;
            }
          }


          // this.getReport();
          
        } else if (response.data.code === 1) {
          this.$message.error(response.data.msg);

        } else {
          this.$message.error("分析报告未出");
        }
      }, (error)=>{
        console.log(error);
      })
    },

    /**
     * 获取报告url / 获取报告价格
     */
    getReport(gotoView) {
      const instance = this.$loading();
      let url = 'company/hasFile/' + this.comCode + '/' + this.year + '/' + this.type;
      sendRequestIndustry(url, 'get', null, (response)=>{
        // console.log(response)
        instance.close();
        if (response.data.code == 0) {
          if (response.data.data != null) {
            
            this.shareUrl = response.data.data;
            this.buyButtonText = '查看报告';
            this.showBuy = false;

            if(gotoView){
              this.buyButton()
            }

          } else {
            
            this.shareUrl = null;
            this.buyButtonText = '暂无报告';
            this.showBuy = false;

            this.$message.warning("暂无报告，请查询其它公司");
          }
        } else if (response.data.code == '5002') {
          
          this.shareUrl = null;
          this.thisUrl = response.data.data.url;
          this.rankMoney = response.data.data.rankMoney;
          this.buyButtonText = '购买报告（'+response.data.data.rankMoney/100+'元）';
          this.showBuy = true;
        } else {
          
          this.shareUrl = null;
          this.buyButtonText = '暂无报告';
          this.showBuy = false;
          
          this.$message.warning("暂无报告，请查询其它公司");
          
        }
      })
    },

    /**
     * 微信支付
     */
    wxpay() {
      let url = 'orderPayment/wxpay/wxpayNativeType5'
        + '?url=' + this.thisUrl
        // + '&money=' + 1
        + '&money=' + this.rankMoney
        + '&title=' + '财务分析报告';
      sendRequestIndustry(url, 'get', null, response => {
        console.log(response.data)
        if (response.data.code == 0) {
          var codeUrl = response.data.data.code_url;
          this.payUrl = 'https://www.beawan.com/beawanHome/registerController/urlToQRCode?url=' + codeUrl;
          this.payVisible = true;

          $('.el-dialog__headerbtn').click(()=>{
            this.payVisible = false;
          });
        }
      }, error => {
        console.log(error);
      })
    },
    payOver() {
      this.$router.go(0);
    },

    /**
     * 购买按钮
     */
    buyButton() {
      if(this.shareUrl==null && this.showBuy==false){
        this.$message.warning("暂无报告，请查询其它公司");
        return;
      }
      if(this.shareUrl!=null && this.shareUrl.length>1){
        window.open(this.shareUrl)
        // this.$router.push({
        //   name: 'reportView',
        //   params: {
        //     shareUrl: encodeURIComponent(this.shareUrl)
        //   }
        // });
      }else{
        this.wxpay();
      }
    },

    /**
     * 开通会员
     */
    toSubscription() {
      this.$router.push({
        name: 'subscriptionPage'
      });
    },

    viewReport() {
      window.open(this.shareUrl);
    }
    
  }
}
</script>

<style scoped>
.main {
  overflow: hidden;
  height: 100%;
}

.top {
  height: 40px;
  background-color: #F4CAC6;
}
.back {
  display: inline-block;
  width: 50px;
  /* height: 40px; */
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.topTitle {
  display: inline-block;
  /* margin-right: 50px; */
  height: 40px;
  line-height: 40px;
  width: calc(100% - 105px);
  text-align: center;
}

.selectTable {
  border-spacing: 0;
  width: 100%;
  text-align: center;
  border-top: 1px solid #888;
  border-left: 1px solid #888;
  color: #333;
  background-color: #fff;
}
.selectTable td {
  border-bottom: 1px solid #888;
  border-right: 1px solid #888;
  height: 75px;
}
.selectTable td span {
  cursor: pointer;
  font-size: 50px;
  color: darkgray;
}
.freeText {
  height: 0;
  position: relative;
  top: -75px;
  left: 160px;
}
.freeBox {
  width: 40px;
  height: 20px;
  color: #fff;
  font-size: 14px;
  background-color: #f5877c;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.content {
  height: calc(100% - 40px);
}
.reportImage {
  width: 100%;
  height: 800px;
}

.buyBox {
  /* height: 350px;
  width: 100%;
  position: fixed;
  bottom: 70px;
  text-align: center;
  display: flex;
  flex-direction: column; */
  /* background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,1), rgba(255,255,255,1)); */
  /* width: calc(100% - 80px);
  text-align: center;
  padding: 0 40px;
  position: absolute;
  top: calc(50% - 200px); */
  width: 580px;
  text-align: center;
  padding: 0 310px;
  margin: 0 auto;
  position: absolute;
  top: 230px;
}
.text1 {
  font-size: 25px;
  margin-top: 150px;
  margin-left: 45px;
  margin-right: 45px;
  font-weight: 600;
}
.text2 {
  color: #999999;
  font-size: 16px;
  margin-top: 10px;
}
.text3 {
  color: #999999;
  font-size: 17px;
  margin-top: 15px;
}
.buyBox .text {
  font-size: 20px;
  color: #CE9151;
}
.buyBox .img {
  width: 60%;
}
.buyBox .btn {
  background-color: #F3BB6D;
  padding: 12px 24px;
  border-radius: 24px;
  color: #704913;
  font-size: 17px;
  width: 170px;
  border: 0;
  margin-right: 10px;
}
.buyBox .btn2 {
  background-color: #D84B4E;
  padding: 12px 24px;
  border-radius: 24px;
  color: #fff;
  font-size: 17px;
  width: 180px;
  border: 0;
  margin-left: 10px;
}

.footer {
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: row;
  height: 60px;
  width: 1200px;
  border-top: 1px solid #CCCCCC;
}

.footerMenu1 {
  width: 50%;
  line-height: 60px;
  text-align: center;
  color: #D84B4E;
  background-color: #FFFFFF;
}
.footerMenu2 {
  width: 50%;
  line-height: 60px;
  text-align: center;
  color: #FFFFFF;
  background-color: #D84B4E;
  cursor: pointer;
}
.picker {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.moreIcon {
  width: 20px;
  height: 20px;
  margin-left: 5px;
}

.main /deep/ .el-input__inner {
  height: 40px;
  font-size: 16px;
}
.main /deep/ .el-select, 
.main /deep/ .el-input--suffix, 
.main /deep/ .el-input__inner {
  width: 100%;
}
</style>
